import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import {
    Row,
    Col,
    Card,
    CardBody,
    Input,
    Button,
    Table,
    FormGroup,
    Label,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    InputGroup,
    InputGroupAddon,
} from "reactstrap";
import Select from "react-select";
import queryString from "query-string";
import { toast } from "react-toastify";
import { cloneDeep, filter, isEmpty, isNil, startsWith } from "lodash";
import APIClient from "../../helpers/APIClient";
import PageTitle from "../../components/PageTitle";
import PageBody from "../../components/PageBody";
import Pagination from "../../components/Pagination";
import RowLoading from "../../components/RowLoading";
import RowEmpty from "../../components/RowEmpty";
import Loader from "../../components/Loader";
import ModalPopup from "../../components/ModalPopup";
import { connect } from "react-redux";
import { baseUrl } from "../../constants/environment";
import { checkRole } from "../../helpers/Roles";
import IconPlus from "../../assets/images/icon-plus.png";
import IconSearch from "../../assets/images/icon-search.png";
import IconEdit from "../../assets/images/icon-edit.png";
import IconLock from "../../assets/images/icon-lock.png";
import IconUnLock from "../../assets/images/icon-unlock.png";
import IconDolla from "../../assets/images/icon_dolla.png";
import Flatpickr from "react-flatpickr";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import IconCalendarBlack from "../../assets/images/icon/ic_calendar-black.svg";
import PriceUtils from "../../helpers/PriceUtils";
import moment from "moment";
import ReceiptsAdd from "../receipts/ReceiptsAdd";
import IconCheckbox from "../../assets/images/icon-checkbox.png";
import IconCheckboxActive from "../../assets/images/icon-checkbox-active.png";
import IconCheckboxPart from "../../assets/images/icon-checkbox-part.png";
import { useReactToPrint } from "react-to-print";
import DesignationPrint from "./components/DesignationPrint";
import IconPrint from "../../assets/images/ic-print.svg";
// import { ServiceType } from "../../constants/nutriconstant";
import { promises } from "fs";
import { resolve } from "dns";
import { data } from "src/assets/uikit-3.8.0/js/uikit";
const configPage = {
    titlePage: "Danh sách đơn dịch vụ",
    pathPage: "/designation",
    column: 9,
};

const StatusList = [
    // {
    //     value:"",
    //     label: "-Trạng thái thực hiện-"
    // },
    {
        value: 0,
        label: "Mới",
    },
    {
        value: 1,
        label: "Chờ thực hiện",
    },
    {
        value: 2,
        label: "Đang thực hiện",
    },
    {
        value: 3,
        label: "Đã thực hiện",
    },
    {
        value: -1,
        label: "Đã hủy",
    },
    {
        value: '4_5_6_7',
        label: "Đang xử lý",
    },
];

export const PaymentStatusList: any = [
    {
        value: "",
        label: "-Trạng thái thanh toán-"
    },
    {
        value: "paid",
        label: "Đã thanh toán",
    },
    {
        value: "partiallypaid",
        label: "Thanh toán 1 phần",
    },
    {
        value: "unpaid",
        label: "Chưa thanh toán",
    },
];

export const ServiceType: any = [
    {
        value: '',
        label: '-Đối tác thực hiện-',
    },
    {
        value: 'labhouse',
        label: 'Labhouse',
    },
    {
        value: 'medlatec',
        label: 'Medlatec',
    },
    {
        value: 'local',
        label: 'Nội bộ phòng khám'
    }
];

interface Props {
    history: any;
    location: any;
    user: any;
}
const initialParams = {
    page: 1,
    limit: 25,
    filter: {
        from: moment().startOf("day").valueOf(),
        to: moment().endOf("day").valueOf(),
    },
};

const List: React.FC<Props> = (props: Props) => {
    const [{ page, limit, filter }, setParams] = useState<any>(initialParams);
    const [totalElements, setTotalElements] = useState(0);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<any>([]);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [service_group, setServiceGroup] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [clinic, setClinic] = useState([]);
    const [users, setUsers] = useState([]);
    const [action, setAction] = useState<any>({});
    const [ids, setIds] = useState([]);
    const searchPrams = queryString.parse(props.location.search);
    const [designationPrint, setDesignationPrint] = useState<any>([]);
    const [data_ids, setData_ids] = useState<any>([]);
    const [detailDes, setDetailDes] = useState<any>([]);
    const [dataCustomer, setDataCustomer] = useState<any>([]);
    const componentRef = useRef(null);
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        copyStyles: true,
    });

    const setPage = (value: number) => {
        setParams((prevState: any) => ({
            ...prevState,
            page: value,
        }));
    };

    const setLimit = (value: number) => {
        setParams((prevState: any) => ({
            ...prevState,
            limit: value,
        }));
    };

    const setFilter = (value: {}) => {
        setParams((prevState: any) => ({
            ...prevState,
            filter: value,
        }));
    };
    useEffect(() => {
        document.title = configPage.titlePage;
        getFilterParams();
        loadInit();
    }, []);

    useLayoutEffect(() => {
        // if (firstUpdate.current) {
        //     firstUpdate.current = false;
        //     return;
        // }
        // if (!isEmpty(searchPrams)) {
        loadData();
        // }
        setFilterParams({
            page: page,
            limit: limit,
            ...filter,
        });
        setIds([]);
    }, [filter, page, limit]);

    useEffect(() => {
        document.title = configPage.titlePage;
        getFilterParams();
        loadInit();
    }, []);

    useEffect(() => {
        loadData_ids();
        loadCustomer();
    }, [ids]);

    const firstUpdate = useRef(true);

    const handleActionModal = (item: any) => {
        setAction(item);
        setIsOpen(true);
    };

    const getFilterParams = () => {
        const newFilter: any = {};
        if (!isEmpty(searchPrams)) {
            Object.keys(searchPrams).map(function (key) {
                switch (key) {
                    case "page":
                        setPage(Number(searchPrams[key]));
                        break;
                    case "limit":
                        setLimit(Number(searchPrams[key]));
                        break;
                    case "statuses":
                    case "payment_statuses":
                        const values = String(searchPrams[key]);
                        newFilter[key] = values?.split(',');
                        break;
                    default:
                        newFilter[key] = searchPrams[key];
                        break;
                }
            });
            console.log("newFilter", newFilter)
            setFilter(newFilter);
        }
    };

    const setFilterParams = (params: any) => {
        var filterParams = "";
        Object.keys(params).map(function (item, i) {
            if (i === 0) {
                if (params[item])
                    filterParams = filterParams + "?" + item + "=" + params[item];
            } else {
                if (params[item])
                    filterParams = filterParams + "&" + item + "=" + params[item];
            }
        });
        props.history.push({
            search: filterParams,
        });
    };

    const loadInit = async () => {
        const params = {
            status: 1,
            page: 1,
            limit: 1000,
        };
        const [
            responseCustomer,
            responseServiceGroup,
            responseUser,
            responseClinic,
        ] = await Promise.all([
            APIClient.GET(`${baseUrl}/customer`, params),
            APIClient.GET(`${baseUrl}/servicegroup`, params),
            APIClient.GET(`${baseUrl}/user`, params),
            APIClient.GET(`${baseUrl}/clinic`, params),
        ]);
        if (responseCustomer.response?.data !== undefined) {
            let ListArr: any = [];
            responseCustomer.response?.data?.map((e: any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name,
                });
            });
            setCustomers(ListArr);
        }
        if (responseServiceGroup.response?.data !== undefined) {
            let ListArr: any = [];
            responseServiceGroup.response?.data?.map((e: any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name,
                });
            });
            setServiceGroup(ListArr);
        }
        if (responseUser.response?.data !== undefined) {
            let ListArr: any = [];
            responseUser.response?.data?.map((e: any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name,
                });
            });
            setUsers(ListArr);
        }
        if (responseClinic.response?.data !== undefined) {
            let ListArr: any = [];
            responseClinic.response?.data?.map((e: any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name,
                });
            });
            setClinic(ListArr);
        }
    };

    const loadData = async () => {
        setLoading(true);

        const formData = {
            page: page,
            limit: limit,
            branch_id: props?.user?.branch_id?.id,
            ...filter,
            include_service: true,
            include_orderspackage: true
        };
        if (formData?.name === "") {
            delete formData?.name;
        }
        if (formData?.statuses) {
            const statuses = formData?.statuses?.reduce((prev:any, item:any)=>{
                const items = item?.split('_')
                if(items?.length > 0){
                  prev = [...prev, ...items]
                }else{
                  prev = [...prev, item]
                }
                return prev
            },[])
            formData.statuses = statuses
        }
        if (formData?.from && formData?.to) {
            formData.from = moment(formData?.from).startOf("day").valueOf();
            formData.to = moment(formData?.to).endOf("day").valueOf();
        }
        const url = `${baseUrl}/designation`;
        let response: any = await APIClient.GET(url, formData);
        setLoading(false);
        if (response.error !== undefined) {
            toast.error(response.error);
        } else if (response.response?.data !== undefined) {
            setData(response?.response?.data);
            setTotalElements(response?.response?.total);
        }
    };

    const loadData_ids = async () => {
        const urlDataIds: any = [];
        ids?.map((item: any) => {
            urlDataIds.push(`${baseUrl}/designation/${item}`)
        })
        const apiDataIds: any = [];
        urlDataIds?.map((item: any) => {
            apiDataIds.push(APIClient.GET(item))
        })
        Promise.all(apiDataIds).then((values) => {

            let ArrDes_id: any = [];
            let ArrDesService: any = [];

            values?.map((item: any) => {
                ArrDes_id.push(item?.response?.designation_services)
            })
            ArrDes_id?.map((item: any) => {
                item?.map((data: any) => {
                    ArrDesService.push(data?.service_id)
                })
            })
            setData_ids(ArrDesService)
        })
    };

    const loadCustomer = () => {
        let ArrCustomer: any = []
        data?.map((item: any) => {
            ids?.map((cus: any) => {
                if (item?.id == cus) ArrCustomer.push(item)
            })
        })
        setDataCustomer(ArrCustomer)
    }
    return (
        <React.Fragment>
            <PageTitle
                breadCrumbItems={[{ label: configPage.titlePage, active: true }]}
                title={configPage.titlePage}
            />
            <PageBody>
                <DataFilter
                    filter={filter}
                    service_group={service_group}
                    customers={customers}
                    clinic={clinic}
                    users={users}
                    page={page}
                    limit={limit}
                    configPage={configPage}
                    ids={ids}
                    setIds={setIds}
                    setFilter={(filter: any) => setFilter(filter)}
                    handleActionModal={(data: any) => handleActionModal(data)}
                    setLoading={setLoading}
                    handlePrint={() => handlePrint()}
                    data_ids={data_ids}
                    setDesignationPrint={setDesignationPrint}
                    setDetailDes={setDetailDes}
                    detailDes={detailDes}
                    user={props?.user}
                    dataCustomer={dataCustomer}
                    loadData={() => loadData()}
                    loadCustomer={loadCustomer}
                />
                <DataTableList
                    user={props?.user}
                    data={data}
                    loading={loading}
                    page={page}
                    limit={limit}
                    configPage={configPage}
                    history={props.history}
                    ids={ids}
                    setIds={setIds}
                    handleActionModal={(data: any) => handleActionModal(data)}
                    handlePrint={() => handlePrint()}
                    setLoading={setLoading}
                    setDesignationPrint={setDesignationPrint}
                    loadData={() => loadData()}
                />
                <Pagination
                    link={configPage.pathPage + "/list"}
                    setPage={(page: number) => setPage(page)}
                    page={page}
                    limit={limit}
                    setLimit={(limit: number) => setLimit(limit)}
                    totalElements={totalElements}
                />
            </PageBody>
            <ModalPopup isOpen={modalIsOpen} onRequestClose={() => setIsOpen(false)}>
                {action?.type === "addReceipts" ? (
                    <ReceiptsAdd
                        closeModal={() => setIsOpen(false)}
                        action={action}
                        loadData={() => loadData()}
                        designation_id={action?.designation_id}
                        designation_ids={action?.designation_ids}
                        loadData_ids={() => loadData_ids()}
                    />
                ) : (
                    <RenderActionModal
                        {...props}
                        closeModal={() => setIsOpen(false)}
                        action={action}
                        loadData={() => loadData()}
                        handlePrint={() => handlePrint()}
                        setDesignationPrint={setDesignationPrint}
                    />
                )}
            </ModalPopup>
            <div style={{ overflow: "hidden", height: 0 }}>
                <DesignationPrint
                    componentRef={componentRef}
                    data={designationPrint}
                    detailDes={detailDes[0]}
                />
            </div>
        </React.Fragment>
    );
};

const DataTableList = (props: any) => {
    const {
        data,
        filter,
        loading,
        limit,
        page,
        configPage,
        handleActionModal,
        ids,
        setIds,
        setLoading,
        handlePrint,
        setDesignationPrint,
        loadData,
    } = props;
    const start = limit * (page - 1);
    const checkedIds = (id: any) => {
        const idsTMP = cloneDeep(ids);
        return idsTMP.find((item: any) => {
            return item === id;
        });
    };

    const checkAll = (e: any) => {
        if (e.target.checked) {
            setIds(
                data?.reduce((prev: any, item: any) => {
                    prev = [...prev, item?.id];
                    return prev;
                }, [])
            );
        } else {
            setIds([]);
        }
    };

    const toggleIds = (status: any, id: any) => {
        const idsTMP = cloneDeep(ids);
        if (status) {
            //check xem có ko
            if (!checkedIds(id)) {
                idsTMP.push(id);
                setIds(idsTMP);
            }
        } else {
            //remove
            var index = idsTMP.indexOf(id);
            if (index !== -1) {
                idsTMP.splice(index, 1);
                setIds(idsTMP);
            }
        }
    };

    const RenderHeadData = () => {
        return (
            <thead>
                <tr>
                    <th style={{ minWidth: 130 }}>
                        <div
                            className="nutri-checkbox"
                            onClick={() =>
                                checkAll({
                                    target: {
                                        checked: !(ids?.length > 0 && ids?.length === data?.length),
                                    },
                                })
                            }
                        >
                            <div className="icon">
                                {ids?.length > 0 && ids?.length === data?.length ? (
                                    <img
                                        src={IconCheckboxActive}
                                        height={20}
                                        width={20}
                                        alt="icon"
                                    />
                                ) : ids?.length > 0 && ids?.length !== data?.length ? (
                                    <img
                                        src={IconCheckboxPart}
                                        height={20}
                                        width={20}
                                        alt="icon"
                                    />
                                ) : (
                                    <img src={IconCheckbox} height={20} width={20} alt="icon" />
                                )}
                            </div>
                            <div className="ml-2">Mã phiếu</div>
                        </div>
                    </th>
                    <th style={{ minWidth: 100 }}>Mã BSO</th>
                    <th style={{ minWidth: 100 }}>Đối tác</th>
                    <th style={{ minWidth: 120 }}>Khách hàng</th>
                    <th style={{ minWidth: 120 }}>Ngày thực hiện</th>
                    <th style={{ minWidth: 80 }}>Số lượng</th>
                    <th style={{ minWidth: 120 }}>Thành tiền</th>
                    <th style={{ minWidth: 100 }}>Trạng thái thanh toán</th>
                    <th style={{ minWidth: 100 }}>{`Trạng thái thực hiện`}</th>
                    <th style={{ minWidth: 100 }}>Thao tác</th>
                </tr>
            </thead>
        );
    };

    const RenderBobyData = () => {
        const router = useHistory();
        if (loading) {
            return (
                <RowLoading column={configPage.column} row={data.length || limit} />
            );
        }
        if (data.length === 0) {
            return (
                <RowEmpty column={configPage.column} title="Chưa có đơn dịch vụ nào!" />
            );
        }
        const gotoDetail = (item: any) => {
            router?.push(`/designation/${item?.id}/view`);
        };

        const getLabelStatus = (status: any) => {
            switch (status) {
                case -1: {
                    return <span className="text-danger">Đã hủy</span>;
                    break;
                }
                case 0: {
                    return <span className="text-dark">Mới</span>;
                    break;
                }
                case 1: {
                    return <span className="text-warning">Chờ thực hiện</span>;
                    break;
                }
                case 2: {
                    return <span className="text-info">Đang thực hiện</span>;
                    break;
                }
                case 3: {
                    return <span className="text-success">Đã thực hiện</span>;
                    break;
                }
                case 4: 
                case 5: 
                case 6: 
                case 7: {
                    return <span className="text-warning">Đang xử lý</span>;
                    break;
                }
                default: {
                    return null;
                    break;
                }
            }
        };

        const getLabelPaymentStatus = (status: any) => {
            switch (status) {
                case "paid": {
                    return <span className="text-success">Đã thanh toán</span>;
                    break;
                }
                case "partiallypaid": {
                    return <span className="text-info">Thanh toán 1 phần</span>;
                    break;
                }
                case "unpaid": {
                    return <span className="text-warning">Chưa thanh toán</span>;
                    break;
                }
                default: {
                    return <span className="text-primary">Miễn phí</span>;
                    break;
                }
            }
        };
        const checkPaymentStatus = (status: any) => {
            return !(status == "paid" || status == null);
        }
        // check service đã in
        const fetchServicePrint = async (id: any) => {
            setLoading(true);
            const url = `${baseUrl}/designation/printed`;
            const params = {
                designation_ids: [id],
            };
            let response: any = await APIClient.POST(url, params);
            setLoading(false);
            if (response.error !== undefined) {
                toast.error(response.error.error_description);
            } else if (response.response !== undefined) {
                const resData = response.response;
            }
        };

        const loadDetailDes = async (id: number) => {
            const url = `${baseUrl}/designation/${id}`;
            setLoading(true);
            let response: any = await APIClient.GET(url);
            setLoading(false);
            if (response.error !== undefined) {
                toast.error(response.error.error_description);
            } else if (response.response !== undefined) {
                const resData = await response.response;
                // const checkPrinted = resData?.reduce((prev: any, item: any) => {
                //     if(item?.printed == true) prev = false
                //     return prev
                // }, true)
                if (resData?.printed !== true) {
                    fetchServicePrint(id);
                    handlePrintDesignation(resData);
                    loadData();
                    return;
                }
                handleActionModal({ type: "printed", data: resData });
            }
        };

        const checkServiceQuantity = (item: any) => {
            let quantity = 0;
            item?.map((arr: any) => {
                quantity += arr?.service_quantity
            })
            return quantity
        }

        const checkServiceTotal = (item: any, value: any) => {
            let total = 0;
            let discount = 0;
            item?.[0]?.service_id?.partner == null ? 
            discount = Number(value?.examination_id?.orderspackage_id?.orderspackage_services?.[0]?.discount_service_examination || 0) / 100
            : discount = Number(value?.examination_id?.orderspackage_id?.orderspackage_services?.[0]?.discount_service_partner_examination || 0) / 100

            item?.map((arr: any) => {
                total += arr?.service_total
            })

            return total
            return total - (total * discount)
        }
        return (
            <tbody>
                {data &&
                    data?.length > 0 &&
                    data?.map((item: any, index: number) => {
                        const checked = checkedIds(item?.id);
                        return (
                            <tr key={`${item?.id}-${index}`}>
                                <td>
                                    <div
                                        className="nutri-checkbox"
                                        onClick={() => {
                                            toggleIds(!checked, item?.id)
                                        }}
                                    >
                                        <div className="icon">
                                            {checked ? (
                                                <img
                                                    src={IconCheckboxActive}
                                                    height={20}
                                                    width={20}
                                                    alt="icon"
                                                />
                                            ) : (
                                                <img
                                                    src={IconCheckbox}
                                                    height={20}
                                                    width={20}
                                                    alt="icon"
                                                />
                                            )}
                                        </div>
                                        <div className="ml-2" onClick={() => gotoDetail(item)}>
                                            {item?.code}
                                        </div>
                                    </div>
                                </td>
                                <td onClick={() => gotoDetail(item)}>{item?.erp_order_bso || "---"}</td>
                                <td onClick={() => gotoDetail(item)}>{item?.partner || "---"}</td>
                                <td onClick={() => gotoDetail(item)}>
                                    {item?.customer_id?.code} {item?.customer_id?.name}
                                </td>
                                <td onClick={() => gotoDetail(item)}>
                                    {moment(item?.day).format("DD/MM/YYYY")}
                                </td>
                                <td onClick={() => gotoDetail(item)}>
                                    {checkServiceQuantity(item?.designation_services)}
                                </td>
                                <td onClick={() => gotoDetail(item)}>
                                    {/* {PriceUtils.format(checkServiceTotal(item?.designation_services, item))} */}
                                    {PriceUtils.format(item?.sub_total || checkServiceTotal(item?.designation_services, item))}
                                </td>
                                <td onClick={() => gotoDetail(item)}>
                                    {
                                        item?.id ? (getLabelPaymentStatus(item?.payment_status)) : "---"
                                    }
                                </td>
                                <td onClick={() => gotoDetail(item)}>
                                    {getLabelStatus(item?.status)}
                                </td>
                                <td>
                                    <div className="table-action">
                                        {checkPaymentStatus(item?.payment_status) && (
                                            <div
                                                className="button-nutri"
                                                onClick={() =>
                                                    props?.handleActionModal({
                                                        type: "addReceipts",
                                                        designation_id: item?.id,
                                                    })
                                                }
                                            >
                                                <img
                                                    style={{ border: "none" }}
                                                    src={IconDolla}
                                                    width={20}
                                                    height={20}
                                                    alt=""
                                                />
                                            </div>
                                        )}
                                        {item?.partner == null && (
                                            <div
                                                className="button-nutri"
                                                onClick={() => router?.push(`/designation/${item?.id}`)}
                                            >
                                                <img
                                                    style={{ border: "none" }}
                                                    src={IconEdit}
                                                    width={20}
                                                    height={20}
                                                    alt=""
                                                />
                                            </div>
                                        )}
                                        {item?.payment_status == "paid" && (
                                            <div className="button-nutri">
                                                <img
                                                    style={{ border: "none" }}
                                                    src={IconPrint}
                                                    onClick={() => {
                                                        if (
                                                            !checkRole(
                                                                props?.user?.roles,
                                                                ["printDesignation"],
                                                                props?.user?.role
                                                            )
                                                        ) {
                                                            props.handleActionModal({
                                                                type: "showPrint",
                                                                data: data,
                                                            });
                                                            return;
                                                        }
                                                        loadDetailDes(item?.id);
                                                    }}
                                                    width={20}
                                                    height={20}
                                                    alt=""
                                                />
                                            </div>
                                        )}
                                        {(item?.status === 0 || item?.payment_status === "unpaid") &&
                                            item?.partner == null && (
                                                <div
                                                    className="button-nutri"
                                                    onClick={() =>
                                                        props?.handleActionModal({
                                                            type: "delete",
                                                            data: item,
                                                        })
                                                    }
                                                >
                                                    <i className="uil-trash-alt"></i>
                                                </div>
                                            )}
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
            </tbody>
        );
    };

    const handlePrintDesignation = (item: any) => {
        setDesignationPrint(item);
        setTimeout(() => {
            handlePrint();
        }, 1000);
    };

    return (
        <div>
            {/* <h4 className="header-title mt-0 mb-3">Danh sách {configPage.titlePage}</h4> */}
            <Table className="mb-0 table-custom" responsive>
                <RenderHeadData />
                <RenderBobyData />
            </Table>
            {/* {loading && <Loader />} */}
        </div>
    );
};

const DataFilter = (props: any) => {
    const {
        setFilter,
        filter,
        page,
        limit,
        users,
        service_group,
        clinic,
        ids,
        setIds,
        data_ids,
        setLoading,
        handlePrint,
        setDesignationPrint,
        handleActionModal,
        setDetailDes,
        detailDes,
        dataCustomer,
        loadData,
        loadCustomer
    } = props;
    const [payment, setpayment] = useState<any>([])

    useEffect(() => {
        statics()
    }, [filter])

    const [name, setName] = useState(filter?.name);
    const timer = useRef<any>(null);

    const handleKeyDown = (e: any) => {
        if (e.key === "Enter") {
            clearTimeout(timer.current);
            setFilter({
                ...filter,
                page: 1,
                name: e.target.value,
            });
        }
    };

    const handleChange = (e: any) => {
        clearTimeout(timer.current);
        const { name, value } = e?.target;
        setFilter({
            ...filter,
            page: 1,
            [name]: value,
        });
    };

    const handleChangeFilterDate = (date: any) => {
        if (date.length === 2) {
            const from = moment(date[0]).startOf("day").valueOf()
            const to = moment(date[1]).endOf("day").valueOf();
            setFilter({
                ...filter,
                from: from,
                to: to,
            });
        } else if (date.length === 0) {
            setFilter({
                ...filter,
                from: undefined,
                to: undefined,
            });
        }
    };

    const handleFilterMulti = (name: string, option: any, onChange: any) => {
        const value: any = [];
        option &&
            option.map((item: any) => {
                value.push(item.value);
            });
        onChange({ target: { name, value } });
    };

    const getFilterMulti = (list: any, value: any) => {
        if (value instanceof Array) {
            const option: any = [];
            list &&
                list.map((item: any) => {
                    const found =
                        value.length > 0 &&
                        value.find((element: any) => element == item.value);
                    if (found || found === 0) {
                        option.push(item);
                    }
                });
            return option;
        }
        return [];
    };
    // check service đã in
    const fetchServicePrintFilter = async (id: any) => {
        setLoading(true);
        const url = `${baseUrl}/designation/printed`;
        if (id?.length > 1) {
            const params = {
                designation_ids: id,
            };
            let response: any = await APIClient.POST(url, params);
            setLoading(false);
            if (response.error !== undefined) {
                toast.error(response.error.error_description);
            } else if (response.response !== undefined) {
                const resData = response.response;
            }
            return;
        }

        const params = {
            designation_ids: id,
        };
        let response: any = await APIClient.POST(url, params);
        setLoading(false);
        if (response.error !== undefined) {
            toast.error(response.error.error_description);
        } else if (response.response !== undefined) {
            const resData = response.response;
        }
    };

    const handlePrintDesignation = (item: any) => {
        setDesignationPrint(item);
        setTimeout(() => {
            handlePrint();
        }, 1000);
    };

    const loadDetailDes = async (id: any, check?: any) => {
        let urls: any[] = [];
        id?.map((item: any) => {
            urls.push(`${baseUrl}/designation/${item}`);
        });
        let responses: any[] = [];
        urls?.map((item: any) => {
            responses.push(APIClient.GET(item));
        });
        return Promise.all(responses).then((values: any[]) => {
            let thenPromise: any[] = [];
            values?.map((item: any) => thenPromise.push(item?.response));
            setDetailDes(thenPromise);
            if (check == true) {
                return thenPromise
            }
        });
    };

    const statics = async () => {
        const formData = {
            ...filter,
        };
        if (formData?.statuses) {
            const statuses = formData?.statuses?.reduce((prev:any, item:any)=>{
                const items = item?.split('_')
                if(items?.length > 0){
                  prev = [...prev, ...items]
                }else{
                  prev = [...prev, item]
                }
                return prev
            },[])
            formData.statuses = statuses
        }
        const url = `${baseUrl}/designation/statics`;
        let response: any = await APIClient.GET(url, formData);
        if (response.error !== undefined) {
            toast.error(response.error.error_description);
        } else if (response.response !== undefined) {
            const resData = await response.response;
            setpayment(resData)
        }
    };


    return (
        <Row className="mb-3 filter-custom">
            <Col xl={10}>
                <Row>
                    <Col xl={12}>
                        <Row>
                            <Col xl={3}>
                                <InputGroup>
                                    <InputGroupAddon
                                        addonType="prepend"
                                        className="input-group-prepend-input"
                                    >
                                        <img src={IconSearch} width={18} height={18} alt="" />
                                    </InputGroupAddon>
                                    <Input
                                        className="mb-2"
                                        onKeyDown={handleKeyDown}
                                        onChange={(e: any) => setName(e.target.value)}
                                        type="text"
                                        value={name}
                                        placeholder="Tên dịch vụ hoặc mã dịch vụ, số điện thoại, mã khách hàng"
                                    />
                                </InputGroup>
                            </Col>
                            <Col xl={2}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Bác sĩ-"
                                    options={[
                                        {
                                            label: "-Bác sĩ-",
                                            value: "",
                                        },
                                        ...users,
                                    ]}
                                    onChange={(value: any) => {
                                        handleChange({
                                            target: { name: "doctor_id", value: value.value },
                                        });
                                    }}
                                    value={users?.filter(
                                        (option: any) => filter?.doctor_id === option.value
                                    )}
                                ></Select>
                            </Col>

                            <Col xl={2}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Phòng-"
                                    options={[
                                        {
                                            label: "-Phòng-",
                                            value: "",
                                        },
                                        ...clinic,
                                    ]}
                                    onChange={(value: any) => {
                                        handleChange({
                                            target: { name: "clinic_id", value: value.value },
                                        });
                                    }}
                                    value={clinic?.filter(
                                        (option: any) => filter?.clinic_id === option.value
                                    )}
                                ></Select>
                            </Col>
                            <Col xl={2}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Nhóm dịch vụ-"
                                    options={[
                                        {
                                            label: "-Nhóm dịch vụ-",
                                            value: "",
                                        },
                                        ...service_group,
                                    ]}
                                    onChange={(value: any) => {
                                        handleChange({
                                            target: { name: "service_group_id", value: value.value },
                                        });
                                    }}
                                    value={service_group?.filter(
                                        (option: any) => filter?.service_group_id === option.value
                                    )}
                                ></Select>
                            </Col>
                            <Col xl={3}>
                                <InputGroup className="form-control picker-custom">
                                    <Flatpickr
                                        value={[
                                            new Date(
                                                moment(filter?.from)
                                                    .startOf("day")
                                                    .valueOf()
                                            ),
                                            new Date(
                                                moment(filter?.to)
                                                    .startOf("day")
                                                    .valueOf()
                                            ),
                                        ]}
                                        onChange={(date: any) => {
                                            handleChangeFilterDate(date);
                                        }}
                                        options={{
                                            mode: "range",
                                            locale: Vietnamese,
                                            dateFormat: "d/m/Y",
                                        }}
                                        className="flatpickr-input active"
                                        placeholder="Ngày chỉ định"
                                    />
                                    <div
                                        className="icon-clear"
                                        style={{ right: 23 }}
                                        onClick={() => {
                                            setFilter({ ...filter, from: null, to: null });
                                        }}
                                    >
                                        <i className="uil-times mr-1"></i>
                                    </div>
                                    <InputGroupAddon
                                        addonType="append"
                                        className="d-flex align-items-center"
                                    >
                                        <img src={IconCalendarBlack} alt="icon" />
                                    </InputGroupAddon>
                                </InputGroup>
                            </Col>
                            <Col xl={5}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Trạng thái thực hiện-"
                                    options={StatusList}
                                    // onChange={(value: any) => {
                                    //     handleChange({ target: { name: 'status', value: value.value } })
                                    // }}
                                    // value={StatusList?.filter((option: any) => filter?.status === option.value)}
                                    isMulti
                                    onChange={(val: any) => {
                                        handleFilterMulti("statuses", val, handleChange);
                                    }}
                                    value={getFilterMulti(StatusList, filter?.statuses || [])}
                                ></Select>
                            </Col>
                            <Col xl={4}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Trạng thái thanh toán-"
                                    options={PaymentStatusList}
                                    // onChange={(value: any) => {
                                    //     handleChange({ target: { name: 'payment_status', value: value.value } })
                                    // }}
                                    // value={PaymentStatusList?.filter((option: any) => filter?.payment_status === option.value)}
                                    isMulti
                                    onChange={(val: any) => {
                                        handleFilterMulti("payment_statuses", val, handleChange);
                                    }}
                                    value={getFilterMulti(
                                        PaymentStatusList,
                                        filter?.payment_statuses || []
                                    )}
                                ></Select>
                            </Col>
                            <Col xl={3}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Đối tác thực hiện-"
                                    options={ServiceType}
                                    onChange={(value: any) => {
                                        handleChange({
                                            target: { name: "partner", value: value.value },
                                        })
                                    }}
                                    value={ServiceType?.filter(
                                        (option: any) => filter?.partner === option.value
                                    )}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
            <Col xl={2}>
                <div className="text-right">
                    <div style={{ position: "absolute", top: 0, left: 0, textAlign: "left", fontSize: "12px", }}>
                        <p>Tổng tiền : <span style={{ color: "green", fontWeight: "bold" }}>{parseFloat(payment?.service_total || 0).toLocaleString('vi-VN', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} ₫ </span></p>
                        <p>
                            Tổng thiếu :
                            <span style={{ color: "red", fontWeight: "bold" }}>
                                {(
                                    parseFloat(payment?.payment_total || "0")
                                ).toLocaleString('vi-VN', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + '₫'}
                            </span>
                        </p>
                        <p >Tổng dịch vụ : <span style={{ fontWeight: "bold" }}>{payment?.service_count}</span></p>
                    </div>
                    {ids?.length > 0 && (
                        <>
                            <div style={{ position: "relative" }}>

                                <div>
                                    <button
                                        type="button"
                                        className="ml-2 btn btn-light"
                                        onClick={() => {
                                            props?.handleActionModal({
                                                type: "addReceipts",
                                                data: {},
                                                designation_ids: ids,
                                            });
                                        }}
                                    >
                                        <img
                                            style={{ border: "none" }}
                                            src={IconDolla}
                                            width={20}
                                            height={20}
                                            alt=""
                                        />
                                    </button>
                                </div>
                            </div>
                        </>
                    )}
                    {ids?.length > 0 &&
                        dataCustomer?.length > 0 &&
                        dataCustomer?.filter(
                            (item: any) =>
                                item?.payment_status && item?.payment_status !== "paid"
                        )?.length === 0 && (
                            <button type="button" className="ml-2 btn btn-light">
                                <img
                                    style={{ border: "none" }}
                                    src={IconPrint}
                                    width={20}
                                    height={20}
                                    alt=""
                                    onClick={async () => {
                                        if (
                                            !checkRole(
                                                props?.user?.roles,
                                                ["printDesignation"],
                                                props?.user?.role
                                            )
                                        ) {
                                            props.handleActionModal({
                                                type: "showPrint",
                                                data: data_ids,
                                            });
                                            return;
                                        }
                                        const detailDess = await loadDetailDes(ids, true);
                                        if (detailDess) {
                                            let checkPayment = detailDess?.reduce((prev: any, item: any) => {
                                                if (
                                                    detailDess[0]?.designation_payments[0]?.payment_method_id?.id !==
                                                    item?.designation_payments[0]?.payment_method_id?.id
                                                ) {
                                                    prev = false;
                                                }
                                                return prev;
                                            }, true);
                                            let checkCustomer = detailDess?.reduce((prev: any, item: any) => {
                                                if (
                                                    detailDess[0]?.customer_id?.id !==
                                                    item?.customer_id?.id
                                                ) {
                                                    prev = false;
                                                }
                                                return prev;
                                            }, true);
                                            if (!checkCustomer) {
                                                toast.warning("chỉ có thể in nhiều phiếu cùng 1 khách hàng");
                                                return
                                            }
                                            if (!checkPayment) {
                                                toast.warning(
                                                    "chỉ có thể in nhiều phiếu có cùng 1 hình thức thanh toán"
                                                );
                                                return;
                                            }
                                            let Arr = dataCustomer?.filter(
                                                (item: any) => item?.printed == true
                                            );
                                            if (Arr?.length == 0) {
                                                fetchServicePrintFilter(ids);
                                                handlePrintDesignation(data_ids);
                                                loadData();
                                                loadCustomer();
                                                return;
                                            }
                                            handleActionModal({ type: "printed", data: data_ids });
                                        }
                                    }}
                                />
                            </button>
                        )}
                    {/* <Link to={`${configPage.pathPage}/add`}><Button color="success" className="ml-2"><img className='mr-1' style={{border: 'none'}} src={IconPlus} width={20} height={20} alt=""/>  Thêm</Button></Link> */}
                </div>

            </Col>
        </Row>
    );
};

const RenderActionModal = (props: any) => {
    const [loading, setLoading] = useState(false);
    const { closeModal, action, loadData, handlePrint, setDesignationPrint } =
        props;
    const handleStop = async () => {
        setLoading(true);
        const url = `${baseUrl}/designation/${action?.data?.id}`;
        const params = {
            status: -1,
        };
        let response: any = await APIClient.PUT(url, params);
        setLoading(false);
        if (response.error !== undefined) {
            toast.error(response.error.error_description);
        } else if (response.response !== undefined) {
            toast.success("Hủy đơn dịch vụ thành công");
            closeModal();
            loadData();
        }
    };

    const handleActive = async () => {
        setLoading(true);
        const url = `${baseUrl}/designation/${action?.data?.id}`;
        const params = {
            status: 1,
        };
        let response: any = await APIClient.PUT(url, params);
        setLoading(false);
        if (response.error !== undefined) {
            toast.error(response.error.error_description);
        } else if (response.response !== undefined) {
            toast.success("Kích hoạt đơn dịch vụ thành công");
            closeModal();
            loadData();
        }
    };

    const handleDelete = async () => {
        setLoading(true);
        const url = `${baseUrl}/designation/${action?.data?.id}`;
        let response: any = await APIClient.DELETE(url);
        setLoading(false);
        if (response.error !== undefined) {
            toast.error(response.error.error_description);
        } else if (response.response !== undefined) {
            toast.success("Xóa chỉ định dịch vụ thành công");
            closeModal();
            loadData();
        }
    };

    const handlePrintt = () => {
        handlePrintDesignation(action?.data);
        closeModal();
    };

    const handlePrintDesignation = (item: any) => {
        setDesignationPrint(item);
        setTimeout(() => {
            handlePrint();
        }, 1000);
    };

    if (!checkRole(props?.user?.roles, ["editDesignation"], props?.user?.role)) {
        return (
            <CardBody className="p-0" style={{ width: 460 }}>
                <div className="modal-header">
                    <h5 className="modal-title" id="modal-action-title">
                        Thông báo
                    </h5>
                    <button onClick={() => closeModal()} type="button" className="close">
                        {" "}
                        <span aria-hidden="true">×</span>{" "}
                    </button>
                </div>
                <div className="modal-body pt-2 pb-2">
                    <Col md={12}>
                        <FormGroup row className="label-only">
                            <p
                                className="font-size-14"
                                style={{ textAlign: "center", width: "100%" }}
                            >
                                Bạn không có quyền thực hiện thao tác này
                            </p>
                        </FormGroup>
                    </Col>
                </div>
                <div className="modal-footer">
                    <Button
                        onClick={closeModal}
                        className="ml-2 success-bland"
                        color="success"
                        type="button"
                    >
                        {" "}
                        Hủy bỏ
                    </Button>
                </div>
                {loading && <Loader />}
            </CardBody>
        );
    }

    if (action?.type == "printed") {
        return (
            <CardBody className="p-0" style={{ width: 600 }}>
                <div className="modal-header">
                    <h5 className="modal-title" id="modal-action-title">
                        Thông báo
                    </h5>
                    <button onClick={() => closeModal()} type="button" className="close">
                        {" "}
                        <span aria-hidden="true">×</span>{" "}
                    </button>
                </div>
                <div className="p-3 pt-4 mb-2 text-center">
                    Dịch vụ này đã được in, bạn có muốn in lại toàn bộ phiếu chỉ định dịch
                    vụ này không?
                </div>
                <div className="modal-footer">
                    <Button
                        onClick={closeModal}
                        className="ml-2 success-bland"
                        color="success"
                        type="button"
                    >
                        {" "}
                        Hủy bỏ
                    </Button>
                    <Button
                        onClick={handlePrintt}
                        className="ml-2"
                        color="success"
                        type="button"
                    >
                        {" "}
                        Xác nhận{" "}
                    </Button>
                </div>
                {loading && <Loader />}
            </CardBody>
        );
    }

    if (action?.type == "showPrint") {
        return (
            <CardBody className="p-0" style={{ width: 460 }}>
                <div className="modal-header">
                    <h5 className="modal-title" id="modal-action-title">
                        Thông báo
                    </h5>
                    <button onClick={() => closeModal()} type="button" className="close">
                        {" "}
                        <span aria-hidden="true">×</span>{" "}
                    </button>
                </div>
                <div className="modal-body pt-2 pb-2">
                    <Col md={12}>
                        <FormGroup row className="label-only">
                            <p
                                className="font-size-14"
                                style={{ textAlign: "center", width: "100%" }}
                            >
                                Bạn không có quyền thực hiện thao tác này
                            </p>
                        </FormGroup>
                    </Col>
                </div>
                <div className="modal-footer">
                    <Button
                        onClick={closeModal}
                        className="ml-2 success-bland"
                        color="success"
                        type="button"
                    >
                        {" "}
                        Hủy bỏ
                    </Button>
                </div>
                {loading && <Loader />}
            </CardBody>
        );
    }

    return (
        <CardBody className="p-0" style={{ width: 400 }}>
            <div className="modal-header">
                <h5 className="modal-title" id="modal-action-title">
                    {action?.type === "stop"
                        ? "Ngừng hoạt động"
                        : action?.type === "active"
                            ? "Kích hoạt đơn dịch vụ"
                            : "Thông báo"}
                </h5>
                <button onClick={() => closeModal()} type="button" className="close">
                    {" "}
                    <span aria-hidden="true">×</span>{" "}
                </button>
            </div>
            <div className="modal-body pt-2 pb-2">
                <Col md={12}>
                    <FormGroup row className="label-only">
                        {action?.type === "stop" && (
                            <>
                                <p
                                    className="font-size-14"
                                    style={{ textAlign: "center", width: "100%" }}
                                >
                                    Bạn có chắc chắn muốn vô hiệu hóa đơn dịch vụ <br />
                                    <b>{action?.data?.phone}</b>
                                </p>
                            </>
                        )}
                        {action?.type === "active" && (
                            <p
                                className="font-size-14"
                                style={{ textAlign: "center", width: "100%" }}
                            >
                                Bạn có chắc chắn muốn kích hoạt đơn dịch vụ này không?
                            </p>
                        )}
                        {action?.type === "delete" && (
                            <p
                                className="font-size-14"
                                style={{ textAlign: "center", width: "100%" }}
                            >
                                Bạn có chắc chắn hủy chỉ định dịch vụ này không?
                            </p>
                        )}
                    </FormGroup>
                </Col>
            </div>
            <div className="modal-footer">
                <Button
                    onClick={() => {
                        action?.type === "stop"
                            ? handleStop()
                            : action?.type === "active"
                                ? handleActive()
                                : action?.type === "delete" && handleStop();
                    }}
                    className="ml-2"
                    color="success"
                    type="button"
                >
                    {" "}
                    Xác nhận{" "}
                </Button>
            </div>
            {loading && <Loader />}
        </CardBody>
    );
};

const mapState = (state: any) => {
    return {
        user: state.Auth.user,
    };
};

export default connect(mapState)(List);
